import loadable from '@loadable/component'

export const CaafTable = loadable(() => import('./CaafTable'))
export type { CaafTableProps } from './CaafTable'
